import React, { useState, useEffect } from 'react'
import Table from '../Community/CommunityTable'
import { useNavigate } from 'react-router-dom';
import { getCommunityApi, deleteCommunityApi, getCommunityCountApi, markImp, downloadcommunityReportByData } from '../Community/CommunityActionCreator'
import Loader from '../../../../presentationals/Loader/Loader.component'
import DeletePopup from '../Community/deletePopup'
import moment from 'moment'
import { FormControl, InputLabel, MenuItem, Select, Tooltip } from '@mui/material';
import { sortingFunction, paginationFuction } from '../CommonUtils';
import SelectMUI from '../CommonComponents/SelectMUI'



const RoleTypeData = [
    {
        code: "operation",
        name: "Operation",
    },
    {
        code: "collection",
        name: "Collection",
    },
]

const CommunityList = ({ handleTab }) => {
    const [searchInput, setSearchInput] = useState({ emailId: '', mobileNo: '', createdOn: '', whoYouAre: '', important: "", communityCode: '', name: '' })
    const navigate = useNavigate();
    const [allData, setAllData] = useState([])
    const [loaderState, setLoaderState] = useState(false)
    const [deletePopupState, setDeletePopupState] = useState(false)
    const [idForDelete, setIdForDelete] = useState('')
    const [totalCount, setTotalCount] = useState(0)
    const [pageNumber, setPageNumber] = useState(1)
    const [noOfRows, setNoOfRows] = useState(10)
    const [, updateState] = React.useState();
    const forceUpdate = React.useCallback(() => updateState({}), []);
    const [trigger, setTrigger] = useState(false)
    const [search, setSearch] = useState('mobile')
    const [applyDateToShow, setapplyDateToShow] = useState();
    const [RoleType, setRoleType] = useState("");




    useEffect(() => {
        getAllDataHandler(pageNumber, noOfRows)
    }, [])

    const getAllDataHandler = (page, rows) => {
        setLoaderState(true)
        const newObj = {...searchInput ,CommRoleType:RoleType}
        getCommunityApi(page, rows, newObj, "", "Amu Agent",
            callBack => {
                setAllData(callBack)
                setLoaderState(false)
                getCountHandler()
            },
            error => {

            })
    }
    const newSorting = (e) => {
        if (e === "firmName") {
            sortingFunction(allData, 'firmName', trigger, callBack => {
                setAllData(callBack.data)
                setTrigger(callBack.trigger === true ? false : true)
                forceUpdate()
            })
        } else if (e === "name") {
            sortingFunction(allData, 'communityName', trigger, callBack => {
                setAllData(callBack.data)
                setTrigger(callBack.trigger === true ? false : true)
                forceUpdate()
            })
        }
    }

    const getCountHandler = (search) => {
        
        getCommunityCountApi(search ? search : searchInput, "", "Amu Agent",RoleType, callBack => {
            setTotalCount(callBack)
        }, error => {

        })
    }
    const markAsImportant = (communityId, status) => {
        setLoaderState(true)
        let flag = true
        if (status === true) {
            flag = false
        }
        if (status === false) {
            flag = true
        }
        markImp(communityId, flag, callBack => {
            getAllDataHandler(pageNumber, noOfRows)
            setLoaderState(false)
        }, error => {
            setLoaderState(false)

        })
    }

    const actionHandler = (type, data) => {
        if (type === 'edit') {

            handleTab({ rowData: data }, "addEditsalesAgent")
        } else if (type === 'delete') {
            setIdForDelete(data?.communityId)
            setDeletePopupState(true)
        } else if (type === 'add') {

            handleTab("", "addEditsalesAgent")
        } else if (type === 'search') {
            // if (searchInput.emailId.length > 0 || searchInput.communityCode.length > 0 || searchInput.mobileNo.length > 0 || searchInput.name.length > 0 || (searchInput.createdOn != null && searchInput.createdOn.length > 0) || RoleType) {
                getAllDataHandler(pageNumber, noOfRows)
            // }
        }
       
    }

    const deleteHandler = (e) => {
        if (e === 'yes') {
            deleteCommunityApi(idForDelete,
                callBack => {
                    getAllDataHandler(pageNumber, noOfRows)
                }, error => {

                })
        } else {

        }
        setDeletePopupState(false)
    }

    const paginationHandler = (pageNo, rows) => {
        setPageNumber(pageNo)
        setNoOfRows(rows)
        getAllDataHandler(pageNo, rows)
    }

    const DetailHandler = (data) => {
        // navigate(Routes.SUPER_ADMIN_COMMUNITY_DETAIL_PAGE, { state: { rowData: data } })
        handleTab(data, "salesAgentDetail")
    }
    const paginationHandlerNew = (type, pageNumber) => {
        paginationFuction(type, pageNumber, totalCount, callBack => {
            console.log(callBack, 'callback')
            setPageNumber(callBack)
            getAllDataHandler(callBack, noOfRows)
        })

    }
    const searchHandlerNew = (e) => {
        setSearch(e.target.value)

    }
    const searchChangeNew = (e, type) => {
        let changeData = Object.assign({}, searchInput)
        if (type === 'phone') {
            changeData.mobileNo = e.target.value
            changeData.emailId = ''
            changeData.createdOn = ''
            setSearchInput(changeData)
            if (e.target.value === '') {
                 const newObj = {...changeData ,CommRoleType:RoleType}
                getCommunityApi(pageNumber, noOfRows, newObj, "", "Amu Agent",
                    callBack => {
                        setAllData(callBack)
                        setLoaderState(false)
                        getCountHandler()
                    },
                    error => {

                    })
            }
        }
        if (type === 'email') {
            changeData.emailId = e.target.value
            changeData.createdOn = ''
            changeData.mobileNo = ''
            setSearchInput(changeData)

            if (e.target.value === '') {
                  const newObj = {...changeData ,CommRoleType:RoleType}
                getCommunityApi(pageNumber, noOfRows, newObj, "", "Amu Agent",
                    callBack => {
                        setAllData(callBack)
                        setLoaderState(false)
                        getCountHandler()
                    },
                    error => {

                    })
            }
        }
        if (type === 'name') {
            changeData.name = e.target.value
            changeData.createdOn = ''
            changeData.mobileNo = ''
            setSearchInput(changeData)

            if (e.target.value === '') {
                  const newObj = {...changeData ,CommRoleType:RoleType}
                getCommunityApi(pageNumber, noOfRows, newObj, "", "Amu Agent",
                    callBack => {
                        setAllData(callBack)
                        setLoaderState(false)
                        getCountHandler()
                    },
                    error => {

                    })
            }
        }
        if (type === 'applyDate') {
            changeData.createdOn = e.target.value
            changeData.mobileNo = ''
            changeData.emailId = ''
            setSearchInput(changeData)
            setapplyDateToShow(e.target.value)
            if (e) {
                changeData.createdOn = (moment(e.target.value).format("DD-MM-YYYY"))
            } else {
                changeData.createdOn = ''
                e = ''
            }
            if (e === '') {
 const newObj = {...changeData ,CommRoleType:RoleType}
                getCommunityApi(pageNumber, noOfRows, newObj, "", "Amu Agent",
                    callBack => {
                        setAllData(callBack)
                        setLoaderState(false)
                        getCountHandler()
                    },
                    error => {

                    })
            }
        }
        if (type === 'communityCode') {

            changeData.createdOn = ''
            changeData.mobileNo = ''
            changeData.emailId = ''
            changeData.communityCode = e.target.value
            setSearchInput(changeData)
            if (e.target.value === '') {
                 const newObj = {...changeData ,CommRoleType:RoleType}
                getCommunityApi(pageNumber, noOfRows, newObj, "", "Amu Agent",
                    callBack => {
                        setAllData(callBack)
                        setLoaderState(false)
                        getCountHandler()
                    },
                    error => {

                    })
            }
        }
        if (type === 'profession') {

            changeData.whoYouAre = e.target.value
            setSearchInput(changeData)
            const newObj = {...changeData ,CommRoleType:RoleType}
            getCommunityApi(pageNumber, noOfRows, newObj, "", "Amu Agent",
                callBack => {
                    setAllData(callBack)
                    setLoaderState(false)
                    getCountHandler(changeData)
                },
                error => {
                    setLoaderState(false)
                })
        }
        if (type === 'important') {

            let flag = true
            if (e === true) {
                flag = false
            }
            if (e === false) {
                flag = true
            }
            changeData.important = flag

            setSearchInput(changeData)
            console.log(changeData, " sssss");
             const newObj = {...changeData ,CommRoleType:RoleType}
            getCommunityApi(pageNumber, noOfRows, newObj, "", "Amu Agent",
                callBack => {
                    setAllData(callBack)
                    setLoaderState(false)
                    getCountHandler(changeData)
                },
                error => {
                    setLoaderState(false)
                })
        }
        if (type === "clearImp") {
            changeData.important = ""
            setSearchInput(changeData)
              const newObj = {...changeData ,CommRoleType:RoleType}
            getCommunityApi(pageNumber, noOfRows, newObj, "", "Amu Agent",
                callBack => {
                    setAllData(callBack)
                    setLoaderState(false)
                    getCountHandler(changeData)
                },
                error => {
                    setLoaderState(false)
                })
        }
    }

    const handleDownload = () => {
        setLoaderState(true)
        downloadcommunityReportByData("", "", "AMU_AGENT", "", callBack => {

            setLoaderState(false)
        })
    }

    return (
        <div className='container-fluid '>
            {deletePopupState ?
                <DeletePopup
                    deleteHandler={deleteHandler}
                />
                : null}
            {loaderState ?
                <Loader />
                :
                <div>
                    {/* <div>
                        <h3 style={{ margin: '0px 0 30px 0' }}>Dealer</h3>
                    </div> */}
                    <div className='row '>
                        {/* <div className='col-sm-12 '> */}
                        <div className='col col-md-8' style={{ display: 'flex', margin: '30px 0 30px 0' }}>
                            <div className=''>

                                <select className='slectsearch' value={search} onChange={(e) => searchHandlerNew(e)}>

                                    <option value='mobile'>By Mobile</option>
                                    <option value='name'>By Name</option>
                                    <option value='email'> By Email</option>
                                    <option value='date'> By Date</option>
                                    <option value='communityCode'> By Community Code</option>


                                </select>
                            </div>
                            <div className=''>
                                {search === 'email' ?
                                    <input value={searchInput.emailId} className='slectinput' placeholder={search} onChange={e => searchChangeNew(e, 'email')} />
                                    : ""}
                                {search === 'mobile' ?
                                    <input value={searchInput.mobileNo} className='slectinput' type='number' placeholder={search} onChange={e => searchChangeNew(e, 'phone')} />

                                    : ""}
                                {search === 'name' ?
                                    <input value={searchInput.name} className='slectinput' type='text' placeholder={search} onChange={e => searchChangeNew(e, 'name')} />

                                    : ""}
                                {search === 'date' ?
                                    <input
                                        value={applyDateToShow}
                                        data-date-format="DD MMMM YYYY"
                                        className='slectinput' type='date' placeholder={search} onChange={e => searchChangeNew(e, 'applyDate')} />
                                    : ""}
                                {search === 'communityCode' ?
                                    <input value={searchInput.communityCode} className='slectinput' placeholder={search} onChange={e => searchChangeNew(e, 'communityCode')} />

                                    : ""}
                            </div>
                            {/* <div className='col-sm-12 col-md-3'>
                                <InputField
                                    label="Search Email Id"
                                    variant="outlined"
                                    value={searchInput.emailId}
                                    name="emailId"
                                    id="emailId"
                                    type="search"
                                    onChange={e => searchChange(e, 'emailId')}
                                    size="small"
                                />
                            </div>
                            <div className='col-sm-12 col-md-3'>
                                <InputField
                                    label="Search Mobile No"
                                    variant="outlined"
                                    value={searchInput.mobileNo}
                                    name="mobileNo"
                                    id="mobileNo"
                                    type="search"
                                    onChange={e => searchChange(e, 'mobileNo')}
                                    size="small"
                                />
                            </div>
                            <div className='col-sm-12 col-md-3'>

                            <DatePicker
                                label="Added On"
                                // format={'dd/MM/yyyy'}
                                value={(searchInput.createdOn!=null && searchInput.createdOn!='')?moment(searchInput.createdOn).format("DD/MM/YYYY"):""}
                                name="createdOn"
                                size="small"
                                onChange={(e) => searchChange(e,'createdOn')}
                                // required={false}
                            />
                            </div> */}

                            <div className='col-sm-12 col-md-3 mt-1'>

                                <SelectMUI
                                    value={RoleType}
                                    label="Role Type"
                                    onChange={e => setRoleType(e)}
                                    name="communityRoleType"
                                    data={RoleTypeData}
                                    variant={""}
                                    customCSS={{
                                        ".MuiFormLabel-root": {
                                            padding: "0 10px"
                                        }
                                    }}
                                />



                            </div>
                            <div className='col-sm-12 col-md-3 mt-1'>
                                <div className='btn-group' style={{ display: 'flex' }}>
                                    <button
                                        className='cred-btn center-block mr-3'
                                        onClick={e => actionHandler('search')}
                                        style={{ padding: '14px 15px', background: '#064254' }}><i style={{ fontSize: '20px' }} className='fa fa-search' /></button>

                                    <button
                                        className='cred-btn center-block'
                                        onClick={e => actionHandler('add')}
                                        style={{ padding: '14px 15px', background: '#064254' }}><i style={{ fontSize: '20px' }} className='fa fa-plus' /></button>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4 col-xs-12" style={{ display: 'flex', margin: '30px 0 30px 0', justifyContent: 'end' }}>
                            <div className='btn-group' style={{ display: 'flex' }}>
                                <button
                                    className='cred-btn center-block mr-3'
                                    onClick={e => handleDownload()}
                                    style={{ padding: '14px 15px', background: '#064254', fontSize: '16px' }}><i className='fa fa-download' /> &nbsp; Download</button>


                            </div>
                        </div>

                        <div className='row' style={{ height: 'calc(100% - 50px)', marginTop: '40px', padding: '0 20px' }}>
                            <div className='col-sm-12 full-height' >
                                <Table
                                    paginationHandlerNew={paginationHandlerNew}
                                    sorting={newSorting}
                                    actionHandler={actionHandler}
                                    allData={allData}
                                    DetailHandler={DetailHandler}
                                    totalCount={totalCount}
                                    pageNumber={pageNumber}
                                    paginationHandler={paginationHandler}
                                    noOfRows={noOfRows}
                                    markAsImportant={markAsImportant}
                                    tableType={"salesAgentTable"}
                                />
                            </div>
                        </div>

                    </div>
                </div>
            }
        </div>
    )
}

export default CommunityList;